import { render, staticRenderFns } from "./LOGINRDRCT.vue?vue&type=template&id=bddf067c"
import script from "./LOGINRDRCTController.ts?vue&type=script&lang=ts&external"
export * from "./LOGINRDRCTController.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports